import { render, staticRenderFns } from "./ListaIscritti.vue?vue&type=template&id=78e87403&scoped=true&"
import script from "./ListaIscritti.vue?vue&type=script&lang=js&"
export * from "./ListaIscritti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e87403",
  null
  
)

export default component.exports